<template lang="pug">
  //- @uploaded -- listener for getting files
  dv-input(
    v-bind="$attrs"
  )
    v-sheet(
      color="transparent"
      width="100%"
    )
      d-file-uploader-base.d-contents(
        v-on="$listeners"
        @uploaded="onUploaded"
        v-slot="{ loading: serverLoading, upload }"
      )
        d-drag-and-drop-input.d-contents(
          :accept="accept"
          :value="value"
          @input="upload"
          v-slot="{ loading, pickFile, dropFiles }"
        )
          d-drag-and-drop-base.d-contents(
            @drop-files="dropFiles"
          )
            v-sheet(
              color="transparent"
              width="100%"
            )
              file-item(
                v-if="value"
                :file="value"
                close
                style="pointer-events: all;"
                @click:close="$emit('input', undefined)"
              )
              file-item.file-item-loader(
                v-else
                :class="[{ 'item-loading': loading || serverLoading }]"
                :hide-prepend-icon="hidePrependIcon"
                @click="pickFile"
              )
                template(#name) Загрузить файл
                template(#description)
                  span Выберите {{ filesTypes }}
                  span(v-if="maxFileSizeInKb")
                    | &nbsp; до {{ maxFileSizeInKb | kbToMb }}
                template(#append)
                  v-progress-circular.ml-auto.align-self-center(
                    v-if="loading || serverLoading"
                    indeterminate
                    color="ui-primary"
                  )
</template>

<script>
import { TYPE_DATA } from '@/constants/filesExtensions';
import FileItem from './FileItem.vue';
import DFileUploaderBase from '../inputs/DFileUploader/DFileUploaderBase.vue';
import DDragAndDropBase from '../inputs/DFileUploader/DDragAndDropBase.vue';
import DDragAndDropInput from '../inputs/DFileUploader/DDragAndDropInput.vue';
import DvInput from '../inputs/DvInput.vue';

export default {
  components: {
    FileItem,
    DFileUploaderBase,
    DDragAndDropBase,
    DDragAndDropInput,
    DvInput,
  },
  filters: {
    kbToMb(val) {
      if (Number.isNaN(val)) return val;
      return `${(val / 1024).toFixed(0)} мб`;
    },
  },
  props: {
    accept: { type: String, default: 'image/*,application/*' },
    hidePrependIcon: { type: Boolean, default: false },
    maxFileSizeInKb: { type: String, default: undefined },
    value: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  computed: {
    filesTypes() {
      if (this.accept === '*') return 'любой файл';
      const mimeTypes = this.accept.split(',').map((item) => item.split('/').at(-1).replace('*', ''));
      const filesValues = Object.values(TYPE_DATA);
      return [...new Set(mimeTypes.map((type) => {
        const fileTypesData = filesValues.filter(({ mimeType }) => mimeType.includes(type));
        return fileTypesData.map(({ extension }) => extension);
      }).flat())].join(', ');
    },
  },
  methods: {
    onUploaded(files) {
      const [file] = files || [];

      if (file?.file) {
        this.$emit('input', file);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-item-loader {
  width: 100%;
  pointer-events: none;
  &:not(.item-loading) {
    cursor: pointer;
    pointer-events: all !important;
  }

}
</style>
